import React from "react";
import "./achievement-card.css";

function AchievementCard({ item }) {
  return (
    <div className="achievement-card">
      <div className="achievement-info">
        <div className="achievement-header">
          <div className="achievement-title-section">
            <label className="achievement-title">{item.title}</label>
            <div className="achievement-organization">
              <label>{item.organization}</label>
            </div>
          </div>
          <div className="achievement-meta">
            <span className="achievement-year">{item.year}</span>
            <span className="achievement-category">{item.category}</span>
          </div>
        </div>
        <div className="achievement-description">
          <p>{item.description}</p>
        </div>
      </div>
    </div>
  );
}

export default AchievementCard;
